import { Routes } from '@angular/router';
import { AppActions, AppSubjects, authorizationGuard } from '@pflegix/authorization';
import { I18nDemoComponent } from '@pflegix/i18n';
import { AppLayoutComponent } from './layout/app.layout.component';
import { authenticatedContentGuard } from './shared/guard/authenticated-content.guard';
import { loginGuard } from './shared/guard/login.guard';
import { LoginViewComponent } from './view/root/children/login/login-view.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authenticatedContentGuard],
    children: [
      {
        path: '',
        component: AppLayoutComponent,
        children: [
          {
            path: '',
            canActivate: [
              authorizationGuard({
                action: AppActions.read,
                subject: AppSubjects.dashboard,
              }),
            ],
            data: { breadcrumb: 'Pflegix' },
            loadChildren: () =>
              import('./view/root/children/dashboard/dashboard-view.routes').then((m) => m.CUSTOMERS_ROUTES),
          },
          {
            path: 'tickets',
            canActivate: [authorizationGuard({ action: AppActions.read, subject: AppSubjects.ticketing })],
            data: { breadcrumb: 'Aufgaben' },
            loadChildren: () =>
              import('./view/root/children/tickets/tickets-view.routes').then((m) => m.TICKETS_ROUTES),
          },
          {
            path: 'customers',
            canActivate: [
              authorizationGuard({
                action: AppActions.read,
                subject: AppSubjects.customerManagement,
              }),
            ],
            data: { breadcrumb: 'Kunden' },
            loadChildren: () =>
              import('./view/root/children/customers/customers-view.routes').then((m) => m.CUSTOMERS_ROUTES),
          },
          {
            path: 'employees',
            canActivate: [
              authorizationGuard({
                action: AppActions.read,
                subject: AppSubjects.employeeManagement,
              }),
            ],
            data: { breadcrumb: 'Mitarbeiter' },
            loadChildren: () =>
              import('./view/root/children/employees/employees-view.routes').then((m) => m.EMPLOYEES_ROUTES),
          },
          {
            path: 'dispatching',
            canActivate: [authorizationGuard({ action: AppActions.read, subject: AppSubjects.dispatching })],
            data: { breadcrumb: 'Planung' },
            loadChildren: () =>
              import('./view/root/children/dispatching/dispatching-view.routes').then((m) => m.DISPATCHING_ROUTES),
          },
          {
            path: 'users',
            canActivate: [authorizationGuard({ action: AppActions.read, subject: AppSubjects.userManagement })],
            data: { breadcrumb: 'Users' },
            loadChildren: () => import('./view/root/children/users/users-view.routes').then((m) => m.USERS_ROUTES),
          },
          {
            path: 'organizations',
            canActivate: [authorizationGuard({ action: AppActions.read, subject: AppSubjects.organizationManagement })],
            data: { breadcrumb: 'Organizations' },
            loadChildren: () =>
              import('./view/root/children/organizations/organizations-view.routes').then(
                (m) => m.ORGANIZATIONS_ROUTES
              ),
          },
          {
            path: 'leads',
            canActivate: [authorizationGuard({ action: AppActions.read, subject: AppSubjects.leadManagement })],
            data: { breadcrumb: 'Interessenten' },
            loadChildren: () => import('./view/root/children/leads/leads-view.routes').then((m) => m.LEADS_ROUTES),
          },
          {
            path: 'orders',
            canActivate: [authorizationGuard({ action: AppActions.read, subject: AppSubjects.orderManagement })],
            data: { breadcrumb: 'Aufträge' },
            title: 'Aufträge',
            loadChildren: () => import('./view/root/children/orders/orders-view.routes').then((m) => m.ORDERS_ROUTES),
          },
          {
            path: 'documentations',
            canActivate: [
              authorizationGuard({ action: AppActions.read, subject: AppSubjects.documentationManagement }),
            ],
            data: { breadcrumb: 'Dokumentationen' },
            loadChildren: () =>
              import('./view/root/children/documentations/documentations-view.routes').then(
                (m) => m.DOCUMENTATIONS_ROUTES
              ),
          },
          {
            path: 'appointments',
            canActivate: [authorizationGuard({ action: AppActions.read, subject: AppSubjects.appointmentManagement })],
            data: { breadcrumb: 'Termine' },
            loadChildren: () =>
              import('./view/root/children/appointments/appointments-view.routes').then((m) => m.APPOINTMENTS_ROUTES),
          },
          {
            path: 'settings',
            canActivate: [authorizationGuard({ action: AppActions.read, subject: AppSubjects.settings })],
            data: { breadcrumb: 'Einstellungen' },
            loadChildren: () =>
              import('./view/root/children/settings/settings-view.routes').then((m) => m.SETTINGS_ROUTES),
          },
          {
            path: 'business-partner-center',
            canActivate: [
              authorizationGuard({
                action: AppActions.read,
                subject: AppSubjects.businessPartnerManagement,
              }),
            ],
            data: { breadcrumb: 'Geschäftspartner' },
            loadChildren: () =>
              import('./view/root/children/business-partner-center/business-partner-center-view.routes').then(
                (m) => m.BUSINESS_PARTNER_CENTER_ROUTES
              ),
          },
          {
            path: 'ratings',
            canActivate: [
              authorizationGuard({
                action: AppActions.read,
                subject: AppSubjects.ratingManagement,
              }),
            ],
            data: { breadcrumb: 'Bewertungen' },
            loadChildren: () =>
              import('./view/root/children/ratings/ratings-view.routes').then((m) => m.RATINGS_ROUTES),
          },
        ],
      },
    ],
  },
  {
    path: '',
    canActivate: [loginGuard],
    children: [
      {
        path: 'login',
        component: LoginViewComponent,
      },
      {
        path: 'register',
        loadChildren: () => import('./view/root/children/register/register.routes').then((m) => m.REGISTER_ROUTES),
      },
    ],
  },
  {
    path: 'notfound',
    loadComponent: () => import('./view/root/children/notfound/notfound.component').then((m) => m.NotfoundComponent),
  },
  {
    path: 'forbidden',
    loadComponent: () =>
      import('./view/root/children/forbidden/forbidden-view.component').then((m) => m.ForbiddenViewComponent),
  },
  {
    path: 'i18n',
    component: I18nDemoComponent,
  },
  { path: '**', redirectTo: '/notfound' },
];
